import React from "react";
import T from "prop-types";

import { GridResult } from "2g-grid";

import useUzivateleGrid from "./useUzivateleGrid";

export function UzivateleGrid({ ico }) {
  const grid = useUzivateleGrid({ ico });
  return <GridResult {...grid} />;
}

UzivateleGrid.propTypes = { ico: T.string };

export default React.memo(UzivateleGrid);
